<template>
  <div>
    <p class="mb-1 text-left">은행</p>
    <v-autocomplete
      v-model="selectedBank"
      :items="banks"
      hide-details
      outlined
      flat
      :disabled="isLoading"
      placeholder="은행을 선택해주세요"
      no-data-text="검색 결과가 없습니다"
      item-text="name"
      item-value="code"
      return-object
    >
      <template v-slot:selection="data">
        <BankItem :bankCode="data.item.bank" :bankName="data.item.name" />
      </template>
      <template v-slot:item="data">
        <BankItem :bankCode="data.item.bank" :bankName="data.item.name" />
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import BankItem from './BankItem.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BankItem,
  },
  data() {
    return {
      isLoading: false,
      selectedBank: null,
    }
  },
  watch: {
    selectedBank(v) {
      this.selectBank(v)
    },
  },
  computed: {
    ...mapGetters('code/bank', {
      banks: 'getBanks',
    }),
  },
  methods: {
    selectBank(v) {
      this.$emit('update:emitSelectBank', v)
    },
  },
}
</script>
